/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления событиями
 */

/**
 * Тип устройства
 */
export enum EventDeviceType {
  /**
   * Значение не указано
   */
  DEVICE_TYPE_UNKNOWN = "DEVICE_TYPE_UNKNOWN",
  /**
   * Домофон
   */
  INTERCOM = "INTERCOM",
  /**
   * Шлагбаум
   */
  BARRIER = "BARRIER",
  /**
   * Калитка
   */
  GATE = "GATE",
  /**
   * СКУД
   */
  ACCESS_CONTROL_PANEL = "ACCESS_CONTROL_PANEL",
  /**
   * Камера
   */
  VIDEOCAMERA = "VIDEOCAMERA",
}
/**
 * Тип устройства
 */
export type EventDeviceTypeResponseEnum = keyof typeof EventDeviceType
/**
 * Тип устройства
 */
export type EventDeviceTypeRequestEnum = Exclude<EventDeviceTypeResponseEnum, "DEVICE_TYPE_UNKNOWN">;

/**
 * Тип события
 */
export enum EventType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Удалённое открытие
   */
  API_OPEN_REMOTE = "API_OPEN_REMOTE",
  /**
   * Открытие по лицу
   */
  FACE_OPEN_REMOTE = "FACE_OPEN_REMOTE",
  /**
   * Открытие по звонку
   */
  PIN_CODE_OPEN_REMOTE = "PIN_CODE_OPEN_REMOTE",
  /**
   * Открытие по DTMF коду
   */
  DTMF_OPEN_REMOTE = "DTMF_OPEN_REMOTE",
  /**
   * Включение аварийного режима
   */
  EMERGENCY_MODE_ON_REMOTE = "EMERGENCY_MODE_ON_REMOTE",
  /**
   * Отключение аварийного режима
   */
  EMERGENCY_MODE_OFF_REMOTE = "EMERGENCY_MODE_OFF_REMOTE",
  /**
   * Открытие по коду
   */
  CODE_OPEN_LOCAL = "CODE_OPEN_LOCAL",
  /**
   * Открытие по ключу
   */
  RFID_OPEN_LOCAL = "RFID_OPEN_LOCAL",
  /**
   * Включение проигрывания звукового предупреждения
   */
  EMERGENCY_ALARM_REMOTE = "EMERGENCY_ALARM_REMOTE",
  /**
   * Получение логопас УЗ устройства в админке
   */
  GET_CREDENTIALS = "GET_CREDENTIALS",
  /**
   * Смена пароля на устройстве, логируется как успешная, так и неуспешная
   */
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  /**
   * Вход пользователя
   */
  USER_ENTRY = "USER_ENTRY",
  /**
   * Открытие по DTMF коду
   */
  DTMF_OPEN_LOCAL = "DTMF_OPEN_LOCAL",
  /**
   * Открытие по номеру машины
   */
  CAR_NUMBER_OPEN_REMOTE = "CAR_NUMBER_OPEN_REMOTE",
  /**
   * Выключение проигрывания звукового предупреждения
   */
  EMERGENCY_ALARM_OFF_REMOTE = "EMERGENCY_ALARM_OFF_REMOTE",
  /**
   * Включение проигрывания звукового предупреждения
   */
  EMERGENCY_ALARM_ON_REMOTE = "EMERGENCY_ALARM_ON_REMOTE",
  /**
   * Устройство открыто сотрудником ЛТП
   */
  DISPATCHER_OPEN = "DISPATCHER_OPEN",
  /**
   * Отказано в доступе сотрудником ЛТП
   */
  DISPATCHER_DENIED_OPEN = "DISPATCHER_DENIED_OPEN",
  /**
   * Открытие по типу авто
   */
  VEHICLE_TYPE_OPEN_REMOTE = "VEHICLE_TYPE_OPEN_REMOTE",
}
/**
 * Тип события
 */
export type EventTypeResponseEnum = keyof typeof EventType
/**
 * Тип события
 */
export type EventTypeRequestEnum = Exclude<EventTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Событие
 */
export type EventRequestDto = {
  /**
   * Тип события.
   * Поле event_type
   */
  type: EventTypeRequestEnum
  /**
   * Идентификатор устройства
   */
  deviceId?: number | null
  /**
   * Тип устройства на момент события
   */
  deviceType?: EventDeviceTypeRequestEnum | "DEVICE_TYPE_UNKNOWN"
  /**
   * Идентификатор компании
   */
  companyId?: number | null
  /**
   * Идентификатор квартиры
   */
  roomId?: number | null
  /**
   * Индекс реле
   */
  relay?: number | null
  /**
   * Идентификатор пользователя
   */
  userId?: number | null
  /**
   * Юзерагент клиента из которого пользователь выполнял запрос
   */
  userAgent?: string | null
  /**
   * Идентификатор дома
   */
  buildingId?: number | null
  /**
   * ОРПОН
   */
  orponId?: string | null
  /**
   * Номер квартиры
   */
  roomNumber?: string | null
  /**
   * Телефон ИВР
   */
  ivrPhoneNumber?: string | null
  /**
   * Телефон гостя / звонящего
   */
  guestPhoneNumber?: string | null
  /**
   * Код / пин код при открытии при звонке
   */
  code?: string | null
  /**
   * RFID номер
   */
  rfid?: string | null
  /**
   * ИД запроса.
   * # Тип: Guid
   */
  requestId?: string | null
  /**
   * Номер телефона с которого было открытие по DTMF коду
   */
  dtmfPhoneNumber?: string | null
  /**
   * Тип УЗ на устройстве.
   * Поле user_type
   */
  userKind?: string | null
  /**
   * Логин на устройстве
   */
  login?: string | null
  /**
   * Пароль на устройстве
   */
  password?: string | null
  /**
   * ip адрес устройства
   */
  host?: string | null
  /**
   * Модель устройства
   */
  deviceModel?: string | null
  /**
   * Идентификатор ключа
   */
  rfidId?: number | null
  /**
   * Идентификатор кода
   */
  codeId?: number | null
  /**
   * Номер машины
   */
  carNumber?: string | null
  /**
   * Операционная система
   */
  os?: string | null
  /**
   * Пуш-токен для устройства
   */
  pushToken?: string | null
  /**
   * ИД камеры.
   * # Тип: Guid
   */
  cameraUid?: string | null
  /**
   * Ссылка на скриншот события
   */
  screenshotUrl?: string | null
  /**
   * Тип ТС
   */
  vehicle?: string | null
  /**
   * Наименование курьерской компании
   */
  courierCompanyName?: string | null
  /**
   * Номер заказа
   */
  orderNumber?: string | null
  /**
   * Идентификатор курьера
   */
  courierId?: string | null
}
/**
 * Событие
 */
export type EventResponseDto = {
  /**
   * Тип события.
   * Поле event_type
   */
  type: EventTypeResponseEnum
  /**
   * Дата создания события.
   * # Тип: DateTime
   */
  readonly raisedAt: string | null
  /**
   * Идентификатор устройства
   */
  deviceId: number | null
  /**
   * Тип устройства на момент события
   */
  deviceType: EventDeviceTypeResponseEnum
  /**
   * Идентификатор компании
   */
  companyId: number | null
  /**
   * Идентификатор квартиры
   */
  roomId: number | null
  /**
   * Индекс реле
   */
  relay: number | null
  /**
   * Идентификатор пользователя
   */
  userId: number | null
  /**
   * Юзерагент клиента из которого пользователь выполнял запрос
   */
  userAgent: string | null
  /**
   * Идентификатор дома
   */
  buildingId: number | null
  /**
   * ОРПОН
   */
  orponId: string | null
  /**
   * Номер квартиры
   */
  roomNumber: string | null
  /**
   * Телефон ИВР
   */
  ivrPhoneNumber: string | null
  /**
   * Телефон гостя / звонящего
   */
  guestPhoneNumber: string | null
  /**
   * Код / пин код при открытии при звонке
   */
  code: string | null
  /**
   * RFID номер
   */
  rfid: string | null
  /**
   * ИД запроса.
   * # Тип: Guid
   */
  requestId: string | null
  /**
   * Номер телефона с которого было открытие по DTMF коду
   */
  dtmfPhoneNumber: string | null
  /**
   * Тип УЗ на устройстве.
   * Поле user_type
   */
  userKind: string | null
  /**
   * Логин на устройстве
   */
  login: string | null
  /**
   * Пароль на устройстве
   */
  password: string | null
  /**
   * ip адрес устройства
   */
  host: string | null
  /**
   * Модель устройства
   */
  deviceModel: string | null
  /**
   * Идентификатор ключа
   */
  rfidId: number | null
  /**
   * Идентификатор кода
   */
  codeId: number | null
  /**
   * Номер машины
   */
  carNumber: string | null
  /**
   * Операционная система
   */
  os: string | null
  /**
   * Пуш-токен для устройства
   */
  pushToken: string | null
  /**
   * ИД камеры.
   * # Тип: Guid
   */
  cameraUid: string | null
  /**
   * Ссылка на скриншот события
   */
  screenshotUrl: string | null
  /**
   * Тип ТС
   */
  vehicle: string | null
  /**
   * Наименование курьерской компании
   */
  courierCompanyName: string | null
  /**
   * Номер заказа
   */
  orderNumber: string | null
  /**
   * Идентификатор курьера
   */
  courierId: string | null
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Событие
   */
  "Event": {
    "kind": "class",
    "text": "Событие",
    "fields": {
      /**
       * Тип события.
       * Поле event_type
       */
      "type": {
        "type": "Event.Type",
        "text": "Тип события.\nПоле event_type",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания события.
       * # Тип: DateTime
       */
      "raisedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания события.\n# Тип: DateTime",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор устройства",
      },
      /**
       * Тип устройства на момент события
       */
      "deviceType": {
        "type": "Event.DeviceType",
        "text": "Тип устройства на момент события",
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор компании",
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор квартиры",
      },
      /**
       * Индекс реле
       */
      "relay": {
        "type": "google.protobuf.Int32Value",
        "text": "Индекс реле",
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя",
      },
      /**
       * Юзерагент клиента из которого пользователь выполнял запрос
       */
      "userAgent": {
        "type": "google.protobuf.StringValue",
        "text": "Юзерагент клиента из которого пользователь выполнял запрос",
      },
      /**
       * Идентификатор дома
       */
      "buildingId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор дома",
      },
      /**
       * ОРПОН
       */
      "orponId": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН",
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер квартиры",
      },
      /**
       * Телефон ИВР
       */
      "ivrPhoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Телефон ИВР",
      },
      /**
       * Телефон гостя / звонящего
       */
      "guestPhoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Телефон гостя / звонящего",
      },
      /**
       * Код / пин код при открытии при звонке
       */
      "code": {
        "type": "google.protobuf.StringValue",
        "text": "Код / пин код при открытии при звонке",
      },
      /**
       * RFID номер
       */
      "rfid": {
        "type": "google.protobuf.StringValue",
        "text": "RFID номер",
      },
      /**
       * ИД запроса.
       * # Тип: Guid
       */
      "requestId": {
        "type": "google.protobuf.StringValue",
        "text": "ИД запроса.\n# Тип: Guid",
      },
      /**
       * Номер телефона с которого было открытие по DTMF коду
       */
      "dtmfPhoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер телефона с которого было открытие по DTMF коду",
      },
      /**
       * Тип УЗ на устройстве.
       * Поле user_type
       */
      "userKind": {
        "type": "google.protobuf.StringValue",
        "text": "Тип УЗ на устройстве.\nПоле user_type",
      },
      /**
       * Логин на устройстве
       */
      "login": {
        "type": "google.protobuf.StringValue",
        "text": "Логин на устройстве",
      },
      /**
       * Пароль на устройстве
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль на устройстве",
      },
      /**
       * ip адрес устройства
       */
      "host": {
        "type": "google.protobuf.StringValue",
        "text": "ip адрес устройства",
      },
      /**
       * Модель устройства
       */
      "deviceModel": {
        "type": "google.protobuf.StringValue",
        "text": "Модель устройства",
      },
      /**
       * Идентификатор ключа
       */
      "rfidId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор ключа",
      },
      /**
       * Идентификатор кода
       */
      "codeId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор кода",
      },
      /**
       * Номер машины
       */
      "carNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер машины",
      },
      /**
       * Операционная система
       */
      "os": {
        "type": "google.protobuf.StringValue",
        "text": "Операционная система",
      },
      /**
       * Пуш-токен для устройства
       */
      "pushToken": {
        "type": "google.protobuf.StringValue",
        "text": "Пуш-токен для устройства",
      },
      /**
       * ИД камеры.
       * # Тип: Guid
       */
      "cameraUid": {
        "type": "google.protobuf.StringValue",
        "text": "ИД камеры.\n# Тип: Guid",
      },
      /**
       * Ссылка на скриншот события
       */
      "screenshotUrl": {
        "type": "google.protobuf.StringValue",
        "text": "Ссылка на скриншот события",
      },
      /**
       * Тип ТС
       */
      "vehicle": {
        "type": "google.protobuf.StringValue",
        "text": "Тип ТС",
      },
      /**
       * Наименование курьерской компании
       */
      "courierCompanyName": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование курьерской компании",
      },
      /**
       * Номер заказа
       */
      "orderNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер заказа",
      },
      /**
       * Идентификатор курьера
       */
      "courierId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор курьера",
      },
    },
  },
  /**
   * Тип устройства
   */
  "Event.DeviceType": {
    "kind": "enum",
    "text": "Тип устройства",
    "values": {
      /**
       * Значение не указано
       */
      "DEVICE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Домофон
       */
      "INTERCOM": {
        "i": 1,
        "text": "Домофон",
      },
      /**
       * Шлагбаум
       */
      "BARRIER": {
        "i": 2,
        "text": "Шлагбаум",
      },
      /**
       * Калитка
       */
      "GATE": {
        "i": 3,
        "text": "Калитка",
      },
      /**
       * СКУД
       */
      "ACCESS_CONTROL_PANEL": {
        "i": 4,
        "text": "СКУД",
      },
      /**
       * Камера
       */
      "VIDEOCAMERA": {
        "i": 5,
        "text": "Камера",
      },
    },
  },
  /**
   * Тип события
   */
  "Event.Type": {
    "kind": "enum",
    "text": "Тип события",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Удалённое открытие
       */
      "API_OPEN_REMOTE": {
        "i": 1,
        "text": "Удалённое открытие",
      },
      /**
       * Открытие по лицу
       */
      "FACE_OPEN_REMOTE": {
        "i": 2,
        "text": "Открытие по лицу",
      },
      /**
       * Открытие по звонку
       */
      "PIN_CODE_OPEN_REMOTE": {
        "i": 3,
        "text": "Открытие по звонку",
      },
      /**
       * Открытие по DTMF коду
       */
      "DTMF_OPEN_REMOTE": {
        "i": 4,
        "text": "Открытие по DTMF коду",
      },
      /**
       * Включение аварийного режима
       */
      "EMERGENCY_MODE_ON_REMOTE": {
        "i": 5,
        "text": "Включение аварийного режима",
      },
      /**
       * Отключение аварийного режима
       */
      "EMERGENCY_MODE_OFF_REMOTE": {
        "i": 6,
        "text": "Отключение аварийного режима",
      },
      /**
       * Открытие по коду
       */
      "CODE_OPEN_LOCAL": {
        "i": 7,
        "text": "Открытие по коду",
      },
      /**
       * Открытие по ключу
       */
      "RFID_OPEN_LOCAL": {
        "i": 8,
        "text": "Открытие по ключу",
      },
      /**
       * Включение проигрывания звукового предупреждения
       */
      "EMERGENCY_ALARM_REMOTE": {
        "i": 9,
        "text": "Включение проигрывания звукового предупреждения",
      },
      /**
       * Получение логопас УЗ устройства в админке
       */
      "GET_CREDENTIALS": {
        "i": 10,
        "text": "Получение логопас УЗ устройства в админке",
      },
      /**
       * Смена пароля на устройстве, логируется как успешная, так и неуспешная
       */
      "CHANGE_PASSWORD": {
        "i": 11,
        "text": "Смена пароля на устройстве, логируется как успешная, так и неуспешная",
      },
      /**
       * Вход пользователя
       */
      "USER_ENTRY": {
        "i": 12,
        "text": "Вход пользователя",
      },
      /**
       * Открытие по DTMF коду
       */
      "DTMF_OPEN_LOCAL": {
        "i": 13,
        "text": "Открытие по DTMF коду",
      },
      /**
       * Открытие по номеру машины
       */
      "CAR_NUMBER_OPEN_REMOTE": {
        "i": 14,
        "text": "Открытие по номеру машины",
      },
      /**
       * Выключение проигрывания звукового предупреждения
       */
      "EMERGENCY_ALARM_OFF_REMOTE": {
        "i": 15,
        "text": "Выключение проигрывания звукового предупреждения",
      },
      /**
       * Включение проигрывания звукового предупреждения
       */
      "EMERGENCY_ALARM_ON_REMOTE": {
        "i": 16,
        "text": "Включение проигрывания звукового предупреждения",
      },
      /**
       * Устройство открыто сотрудником ЛТП
       */
      "DISPATCHER_OPEN": {
        "i": 17,
        "text": "Устройство открыто сотрудником ЛТП",
      },
      /**
       * Отказано в доступе сотрудником ЛТП
       */
      "DISPATCHER_DENIED_OPEN": {
        "i": 18,
        "text": "Отказано в доступе сотрудником ЛТП",
      },
      /**
       * Открытие по типу авто
       */
      "VEHICLE_TYPE_OPEN_REMOTE": {
        "i": 19,
        "text": "Открытие по типу авто",
      },
    },
  },
}